<template>
  <div>
    <launch-control-custom-field-select
      class="mb-100"
      label="Launch Control Status"
      v-model="new_launch_control_status"
      :options="textFields"
    />

    <launch-control-custom-field-select
      class="mb-100"
      label="Launch Control Phone 2"
      v-model="new_phone_2"
      :options="phoneFields"
    />

    <launch-control-custom-field-select
      class="mb-100"
      label="Launch Control Phone 3"
      v-model="new_phone_3"
      :options="phoneFields"
    />

    <launch-control-custom-field-select
      class="mb-100"
      label="Launch Control Apn"
      v-model="new_apn"
      :options="textFields"
    />

    <launch-control-custom-field-select
      class="mb-100"
      label="Launch Control acreage"
      v-model="new_acreage"
      :options="textFields"
    />

    <launch-control-custom-field-select
      class="mb-100"
      label="Launch Control Campaign"
      v-model="new_campaign"
      :options="textFields"
    />

    <button-default
      class="mb-100"
      @click="updateCustomFields"
      :loading="isCustomFieldsUpdating"
      :disabled="isCustomFieldsUpdating"
    >Update Custom Field Mappings
    </button-default>
  </div>
</template>

<script>
import LaunchControlCustomFieldSelect from "./LaunchControlCustomFieldSelect";

export default {
  name: "LaunchControlSettingsCustomFields",
  components: {LaunchControlCustomFieldSelect},
  props: {
    webhook: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isCustomFieldsUpdating: false,
      textFields: [],
      phoneFields: [],
      new_launch_control_status: {
        id: null,
        label: "",
      },
      new_phone_2: {
        id: null,
        label: "",
      },
      new_phone_3: {
        id: null,
        label: "",
      },
      new_apn: {
        id: null,
        label: "",
      },
      new_acreage: {
        id: null,
        label: "",
      },
      new_campaign: {
        id: null,
        label: "",
      },
    };
  },
  computed: {
    launchControlIntegration() {
      return this.$store.getters.launchControlIntegration;
    },
  },
  mounted() {
    this.updateLocalWebhookData(this.webhook);

    if (!this.textFields.length || !this.phoneFields.length) {
      this.getFields();
    }
  },
  methods: {
    getFields() {
      this.$api.fieldMaps.get().then(response => {
        const data = response.data;
        const textFields = [];
        const phoneFields = [];

        for (let parentProp in data) {
          // Only care about Lead Info (aka Custom Fields) for these maps
          for (let prop in data[parentProp]) {
            // add custom fields to appropriate map
            const type = data[parentProp][prop].type;

            if (type === "Custom Field") {
              const validation_type = data[parentProp][prop].validation_type;
              if (validation_type === "text" || validation_type === "textarea") {
                textFields.push({
                  label: `${parentProp} - ${prop}`,
                  value: data[parentProp][prop].field_id,
                });
              }

              if (validation_type === "text" || validation_type === "phone") {
                phoneFields.push({
                  label: `${parentProp} - ${prop}`,
                  value: data[parentProp][prop].field_id,
                });
              }
            }
          }
        }

        this.textFields = textFields;
        this.phoneFields = phoneFields;
      });
    },
    updateCustomFields() {
      const data = {
        "phone_2_id": this.new_phone_2.id === 0 ? null : this.new_phone_2.id,
        "new_phone_2": this.new_phone_2.id === 0 ? this.new_phone_2 : null,
        "phone_3_id": this.new_phone_3.id === 0 ? null : this.new_phone_3.id,
        "new_phone_3": this.new_phone_3.id === 0 ? this.new_phone_3 : null,
        "launch_control_status_id": this.new_launch_control_status.id === 0 ? null : this.new_launch_control_status.id,
        "new_launch_control_status": this.new_launch_control_status.id === 0 ? this.new_launch_control_status : null,
        "apn_id": this.new_apn.id === 0 ? null : this.new_apn.id,
        "new_apn": this.new_apn.id === 0 ? this.new_apn : null,
        "acreage_id": this.new_acreage.id === 0 ? null : this.new_acreage.id,
        "new_acreage": this.new_acreage.id === 0 ? this.new_acreage : null,
        "campaign_id": this.new_campaign.id === 0 ? null : this.new_campaign.id,
        "new_campaign": this.new_campaign.id === 0 ? this.new_campaign : null,
      };

      this.isCustomFieldsUpdating = true;

      this.$api.launchControl.updateCustomFields(this.launchControlIntegration.id, data).then((response) => {
        this.updateLocalWebhookData(response.data);
        this.getFields();
        this.$emit("webhookUpdated", response.data);
        this.isCustomFieldsUpdating = false;

        this.$buefy.toast.open({
          message: "Custom Fields were updated",
          type: "is-success"
        });
      });
    },
    updateLocalWebhookData(webhook) {
      this.new_launch_control_status.id = webhook.field_maps.Status ? webhook.field_maps.Status.field_id : null;
      this.new_phone_2.id = webhook.field_maps.Phone2 ? webhook.field_maps.Phone2.field_id : null;
      this.new_phone_3.id = webhook.field_maps.Phone3 ? webhook.field_maps.Phone3.field_id : null;
      this.new_apn.id = webhook.field_maps.Apn ? webhook.field_maps.Apn.field_id : null;
      this.new_acreage.id = webhook.field_maps.Acreage ? webhook.field_maps.Acreage.field_id : null;
      this.new_campaign.id = webhook.field_maps.CampaigName ? webhook.field_maps.CampaigName.field_id : null;
    },
  }
};
</script>

<style scoped>

</style>
